import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";

const WeekModal = ({ openModal, setOpenModal }) => {
  const [showPlayer, setShowPlayer] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [, setPlayerReady] = useState(false);

  const handleVideo = () => {
    setShowPlayer(true);
  };

  useEffect(() => {
    return () => {
      setOpenModal({ is_open: false, info: {} });
    };
  }, [setOpenModal]);

  useEffect(() => {
    // reset loader when thumbnail changes or modal reopens
    setImageLoaded(false);
    setShowPlayer(false);
    setPlayerReady(false);
  }, [openModal?.info?.thumbnail, openModal?.is_open]);

  // Warm up YouTube connections for faster player load
  useEffect(() => {
    if (!openModal?.is_open) return;
    const urls = [
      "https://www.youtube.com",
      "https://www.google.com",
      "https://i.ytimg.com",
      "https://s.ytimg.com",
    ];
    const links = urls.map((href) => {
      const link = document.createElement("link");
      link.rel = "preconnect";
      link.href = href;
      link.crossOrigin = "";
      document.head.appendChild(link);
      return link;
    });
    return () => {
      links.forEach((l) => {
        if (l && l.parentNode) l.parentNode.removeChild(l);
      });
    };
  }, [openModal?.is_open]);

  return (
    <div>
      <Dialog
        open={openModal?.is_open}
        onClose={() => setOpenModal({ is_open: false, info: {} })}
        as="div"
        style={{ zIndex: "9999999999" }}
        className="fixed inset-0 z-10 flex flex-col items-center justify-center md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black/60 backdrop-blur-[10px]" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-50 my-auto flex flex-col items-center justify-center">
          <div
            className="relative relative my-auto w-[94%] max-w-xl rounded-2xl p-[1px]"
            style={{
              backgroundImage: `linear-gradient(
  to right,
  rgba(255, 255, 255, 0.3) 0%,
  rgba(255, 255, 255, 1) 50%,
  rgba(255, 255, 255, 0.3) 100%
)`,
            }}
          >
            <div
              className="rounded-2xl"
              style={{
                background:
                  "radial-gradient(53.11% 56.94% at 50% 50%, #26496A 0%, #182C3F 100%)",
                boxShadow: "0px 0px 20px 0px #0000004D",
              }}
            >
              <div className="relative h-auto w-full" aria-busy={!imageLoaded}>
                {/* Pre-mounted player for faster start; hidden until showPlayer */}
                <div
                  className={`w-full overflow-hidden rounded-t-2xl ${
                    showPlayer ? "opacity-100" : "opacity-0"
                  } transition-opacity duration-150`}
                >
                  <ReactPlayer
                    url={openModal?.info?.video_link}
                    config={{
                      file: { attributes: { preload: "auto" } },
                      youtube: { playerVars: { modestbranding: 1, rel: 0 } },
                    }}
                    width={"100%"}
                    height={"210px"}
                    controls={showPlayer}
                    playing={showPlayer}
                    onReady={() => setPlayerReady(true)}
                  />
                </div>
                {/* Thumbnail overlay */}
                {!showPlayer && (
                  <div
                    className="absolute inset-0 cursor-pointer"
                    onClick={handleVideo}
                  >
                    {!imageLoaded && (
                      <div className="absolute inset-0 z-10 flex items-center justify-center rounded-t-2xl bg-[#182C3F]">
                        <div className="spinner" />
                      </div>
                    )}
                    <img
                      src={openModal?.info?.thumbnail}
                      alt={openModal?.info?.description || "Week thumbnail"}
                      width={200}
                      height={210}
                      loading="eager"
                      onLoad={() => setImageLoaded(true)}
                      onError={() => setImageLoaded(true)}
                      className={`h-auto w-full rounded-t-2xl ${
                        imageLoaded ? "opacity-100" : "opacity-0"
                      } transition-opacity duration-150`}
                    />
                    <img
                      src="https://img.learntube.ai/public-assets/60422b53334ba439684e57bb/mingcute_youtube-fill.svg"
                      className="absolute top-1/2 left-1/2 h-[48px] w-[48px] -translate-x-1/2 -translate-y-1/2"
                    />
                  </div>
                )}
              </div>
              <div className="flex flex-col items-start justify-start px-3 pt-6 pb-3 leading-none">
                <div className="text-[12px] font-bold text-white/50">
                  WEEK {openModal?.info?.id}
                </div>
                <div className="mt-[6px] text-[18px] font-medium text-white ">
                  {openModal?.info?.description}
                </div>
                <div className="mt-4 text-[16px] font-bold text-[#70AEFF]">
                  You&apos;ll Get:
                </div>
                <div className="mt-3 rounded-[12px] bg-[#406AFF]/10 p-3">
                  {openModal?.info?.points?.map((item, index) => (
                    <div
                      key={index}
                      className={`flex items-start justify-start gap-3 ${
                        openModal?.info?.points?.length - 1 !== index &&
                        "border-b-[1px] border-b-[#70AEFF]/20"
                      } py-2`}
                    >
                      <FontAwesomeIcon
                        icon={faCheck}
                        size="lg"
                        className="text-[#2BBD13]"
                      />
                      <p className="text-[14px] leading-[140%] text-white">
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div
            className="mt-4 flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-full bg-white/20"
            onClick={() => setOpenModal({ is_open: false, info: {} })}
          >
            <img
              src="https://img.learntube.ai/public-assets/recognised_section/X.png?updatedAt=1746165712541"
              className="h-[28px] w-[28px]"
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default WeekModal;
